import { getRowKeysFromRowIds, getTableConversationRelation, listViewStore, } from 'owa-mail-list-store';
import { select } from 'satcheljs/lib/legacy';
// Helper funtion that finds the conversations from all the tables matching
// the folderId and also containing the item id that is passed.
// It then calls the callback to apply the triage action.
// VSO 1458 - we should do the same for pinning and mark junk actions
export default select({
    tableViewConversationRelations: function () { return listViewStore.tableViewConversationRelations; },
    tableViews: function () { return listViewStore.tableViews; },
})(function updateConversationRelations(conversationRowIds, folderId, itemIdsToUpdate, customUpdateFunction, state) {
    conversationRowIds.forEach(function (rowId) {
        state.tableViews.forEach(function (tableView) {
            if (tableView.serverFolderId == folderId) {
                var rowKeys = getRowKeysFromRowIds([rowId], tableView);
                rowKeys.forEach(function (rowKey) {
                    var tableConversationRelation = getTableConversationRelation(rowKey, tableView.id);
                    // The tableConversationRelation can be null, for example,
                    // a read conversation won't be in the unread table view
                    if (!tableConversationRelation) {
                        return;
                    }
                    tableConversationRelation.itemIds.forEach(function (itemId) {
                        // apply the custom update action only if the tableConversationRelation has the specified item.
                        if (itemIdsToUpdate[itemId]) {
                            customUpdateFunction(tableConversationRelation, itemId);
                        }
                    });
                });
            }
        });
    });
});
//# sourceMappingURL=updateConversationRelations.js.map